var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoTiktokIcon = function SvgLogoTiktokIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.07 9.663v-.858a6.636 6.636 0 0 0-.9-.066A6.679 6.679 0 0 0 2.5 15.41a6.667 6.667 0 0 0 2.848 5.462 6.645 6.645 0 0 1-1.791-4.542c0-3.626 2.907-6.583 6.513-6.667Z",
    fill: "#A4A7AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.227 19.376a3.048 3.048 0 0 0 3.04-2.932l.006-14.524h2.654A5.039 5.039 0 0 1 15.84 1h-3.624l-.006 14.525a3.047 3.047 0 0 1-3.04 2.931c-.493 0-.978-.12-1.414-.35a3.041 3.041 0 0 0 2.47 1.27ZM20.883 6.85v-.807a5.01 5.01 0 0 1-2.745-.816 5.044 5.044 0 0 0 2.746 1.623",
    fill: "#A4A7AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.137 5.225a5.019 5.019 0 0 1-1.24-3.305h-.97a5.052 5.052 0 0 0 2.21 3.305Zm-8.966 7.138a3.05 3.05 0 0 0-3.047 3.047 3.049 3.049 0 0 0 1.633 2.696 3.027 3.027 0 0 1-.577-1.776 3.05 3.05 0 0 1 3.047-3.047c.314 0 .614.052.899.141v-3.7a6.634 6.634 0 0 0-.9-.066c-.052 0-.104.004-.157.005v2.841a2.998 2.998 0 0 0-.898-.14Z",
    fill: "#A4A7AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.883 6.85v2.816a8.62 8.62 0 0 1-5.042-1.621v7.365a6.678 6.678 0 0 1-6.67 6.67 6.63 6.63 0 0 1-3.823-1.209A6.652 6.652 0 0 0 10.227 23a6.678 6.678 0 0 0 6.67-6.67V8.965a8.62 8.62 0 0 0 5.043 1.621V6.961c-.363 0-.716-.04-1.057-.112",
    fill: "#A4A7AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.841 15.41V8.045a8.618 8.618 0 0 0 5.042 1.621V6.85a5.044 5.044 0 0 1-2.745-1.624 5.052 5.052 0 0 1-2.211-3.305h-2.654l-.005 14.524a3.048 3.048 0 0 1-3.041 2.932 3.044 3.044 0 0 1-2.47-1.27 3.048 3.048 0 0 1-1.633-2.696 3.05 3.05 0 0 1 3.047-3.047c.313 0 .614.052.899.141V9.663c-3.606.084-6.513 3.04-6.513 6.667 0 1.753.681 3.35 1.791 4.542a6.632 6.632 0 0 0 3.823 1.209 6.678 6.678 0 0 0 6.67-6.671Z",
    fill: "#A4A7AD"
  })));
};
export default SvgLogoTiktokIcon;